import type {ReactElement} from 'react';
import React from 'react';
import {BaseGenerateAiSubtitlesOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/generate-ai-subtitles-option/components/base-generate-ai-subtitles-option/base-generate-ai-subtitles-option';
import {getAiTranscriptParamsForAudio, getSelectableItemDataForAudioData} from '@Libraries/ai-transcript.library';
import {useAiTranscriptGeneration} from '@Hooks/poster-editor/useAiTranscriptGeneration';
import {useSelectedAudioItem} from '@Hooks/poster-editor/useSelectedAudioItem';
import {useAppDispatch} from '@/hooks';
import {GA4EventName, GA4EventParam, GA4EventParamName, trackPosterBuilderGA4Events} from '@Libraries/ga-events';
import {clearGeneratedResults, setAiSubtitlesPanelItems} from '@Panels/ai-subtitle-panel/ai-subtitle-reducer';

export function AudioItemGenerateAiSubtitlesOption(): ReactElement<any> {
  const dispatch = useAppDispatch();

  const selectedAudioItem = useSelectedAudioItem();
  if (!selectedAudioItem) {
    throw new Error('No selected audio item');
  }

  const {getAiSubtitlesActionForItem, addAiTranscripts} = useAiTranscriptGeneration();

  const onGenerateAiSubtitles = async (): Promise<void> => {
    trackPosterBuilderGA4Events(GA4EventName.AI_SUBTITLE_CLICK_CONTEXTUAL_MENU, {[GA4EventParamName.TYPE]: GA4EventParam.AUDIO});

    dispatch(
      setAiSubtitlesPanelItems([
        {
          ...getSelectableItemDataForAudioData(selectedAudioItem.toObject()),
          isSelected: true,
        },
      ])
    );

    dispatch(clearGeneratedResults());

    await addAiTranscripts([getAiTranscriptParamsForAudio(selectedAudioItem.toObject())]);
  };

  return (
    <BaseGenerateAiSubtitlesOption onGenerateClicked={onGenerateAiSubtitles} ctaState={getAiSubtitlesActionForItem(getAiTranscriptParamsForAudio(selectedAudioItem.toObject()))} />
  );
}
